




















import { Component, Mixins } from "vue-property-decorator";
import { State, Mutation } from "vuex-class";
import LayoutView from "@/mixins/layout";
import DefaultLayoutAppBar from "./DefaultLayoutAppBar.vue";
import DefaultLayoutBottomNav from "./DefaultLayoutBottomNav.vue";
import DefaultLayoutModals from "./DefaultLayoutModals.vue";
// import LegalRiskForbidenGuard from "../../components/guard/LegalRiskForbidenGuard.vue";
import LegalRiskConfirmGuard from "../../components/guard/LegalRiskConfirmGuard.vue";
import LegalRiskRejectedGuard from "../../components/guard/LegalRiskRejectedGuard.vue";
import { LegalRiskState } from "@/utils/enum";

@Component({
  components: {
    DefaultLayoutBottomNav,
    DefaultLayoutAppBar,
    DefaultLayoutModals,
    // LegalRiskForbidenGuard,
    LegalRiskConfirmGuard,
    LegalRiskRejectedGuard
  }
})
class DefaultLayout extends Mixins(LayoutView) {
  @State(state => state.app.initing) initing;

  @Mutation("app/SET_APPBAR") setAppbar;

  get meta() {
    const legalRiskState = this.$store.state.app.legalRiskState;

    return {
      showLegalRiskConfirm: legalRiskState === LegalRiskState.NONE,
      showLegalRiskReject: legalRiskState === LegalRiskState.REJECTED
    };
  }

  mounted() {
    this.$store.dispatch("initAccountData");
    this.$common.utils.tasks.setUpPollingTasks(this.$store);

    // set locale
    if (this.$i18n) {
      const locale = this.$common.utils.helper.getLocale();
      this.$i18n.locale = locale;
    }
  }

  beforeDestroy() {
    this.setAppbar({});
  }
}
export default DefaultLayout;
